export const checkIsEmail = (value: string): boolean => {
  const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return re.test(value)
}

export const checkIsPhone = (value: string): boolean => {
  if (!value) return false

  // Удаляем всё, кроме цифр и плюса в начале
  const cleaned = value
    .replace(/[\s\-\(\)]/g, '') // убираем пробелы, скобки, дефисы
    .replace(/^(\+)?[^0-9]*/g, '$1') // оставляем только ведущий +, если есть

  const re = /^\+?[0-9]{6,15}$/
  return re.test(cleaned)
}

export const checkPassword = (value: string): boolean => {
  if (!value.length) return false

  const allowedChars = /^[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]*$/;
  const hasValid = allowedChars.test(value)
  if (!hasValid) return false

  return true
}
